export default __webpack_public_path__ + "static/media/Icon metro-phone.c2239f37.svg";